import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function PageShell({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-brand-cream text-brand-charcoal">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}
